/* ══════════════════════════════════════════════════════════════════════════
   ONEBAR TRADING — obt-mark runtime

   Arms every [data-obt-mark] and draws its ink when the visitor actually
   reaches it. Two rules the rest of the theme learned the hard way:

   1. THE HIDDEN STATE IS NOT OURS. It lives behind html.obt-mk-js, set by an
      inline pre-paint script, so a failed or blocked module leaves every mark
      fully drawn instead of invisible — and there is no paint-then-hide flash.
   2. NEVER read window scroll. On Horizon desktop the window does not scroll —
      .page-wrapper does. IntersectionObserver is viewport-relative and works in
      either case, so that is all this uses. No scroll maths at all.

   Marks that scroll past while the tab was hidden, or that a hash jump skips
   over, are caught by the observer's own initial callback (it fires for every
   observed element on the first frame, intersecting or not).
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__obtMarkReady) return;
  window.__obtMarkReady = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function draw(el) {
    el.classList.add('is-on');
  }

  function boot(root) {
    var marks = (root || document).querySelectorAll('[data-obt-mark]:not([data-mk-ready])');
    if (!marks.length) return;

    for (var i = 0; i < marks.length; i++) marks[i].setAttribute('data-mk-ready', '1');

    if (REDUCE || !('IntersectionObserver' in window)) {
      for (var j = 0; j < marks.length; j++) draw(marks[j]);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        draw(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.5, rootMargin: '0px 0px -8% 0px' });

    for (var m = 0; m < marks.length; m++) io.observe(marks[m]);

    /* Failsafe: whatever the observer has not reported in 3s and is already
       above the fold gets drawn anyway. A mark is decoration on a word that is
       readable either way, so it must never be the reason something looks
       broken. */
    setTimeout(function () {
      for (var n = 0; n < marks.length; n++) {
        var r = marks[n].getBoundingClientRect();
        if (r.bottom > 0 && r.top < (window.innerHeight || 0)) draw(marks[n]);
      }
    }, 3000);
  }

  function scan() { boot(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  /* the cart drawer and the theme editor both inject markup after load */
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
  document.addEventListener('cart:update', scan);
  document.addEventListener('cart:refresh', scan);

  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) { scan(); return; }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  window.obtMarkScan = scan;
})();
